import { isEmpty, isUndefined } from 'lodash';

/**
 * getTooltipTitle
 *
 * Get the title for the tooltip.
 *
 * @param args
 * @param data
 * @param tooltips
 * @returns {*|string|string}
 */
export const getTooltipTitle = (args = {}, data = [], tooltips = []) => {
  if (!isEmpty(data)) {
    const { dataIndex } = args[0];
    const currentData = data[dataIndex];
    return currentData?.yaxisDesc;
  }

  if (!isEmpty(tooltips)) {
    const { dataIndex } = args[0];
    return tooltips?.[dataIndex]?.title;
  }

  return '';
};

/**
 * getTooltipLabel
 *
 * Get the label for the tooltip.
 *
 * @param args
 * @param data
 * @param tooltips
 * @returns {*|string}
 */
export const getTooltipLabel = (args = {}, data = [], tooltips = []) => {
  if (!isEmpty(data)) {
    const { dataIndex } = args;
    const currentData = data[dataIndex];
    return currentData?.name;
  }

  if (!isEmpty(tooltips)) {
    const { dataIndex } = args;
    return tooltips?.[dataIndex]?.label;
  }

  return '';
};

/**
 * getTooltipFooter
 *
 * Get the footer for the tooltip.
 *
 * @param args
 * @param data
 * @param tooltips
 * @returns {*|string}
 */
export const getTooltipFooter = (args = {}, data = [], tooltips = []) => {
  if (!isEmpty(data)) {
    const { dataIndex } = args[0];
    const currentData = data[dataIndex];

    return `\nValue: ${Number(currentData?.value).toLocaleString('en-US')}\nPercentage: ${currentData?.perc}%\n`;
  }

  if (!isEmpty(tooltips)) {
    const { dataIndex, raw } = args[0];

    if (!isUndefined(tooltips?.[dataIndex]?.footer)) {
      return tooltips?.[dataIndex]?.footer;
    }

    return `Total: ${Number(raw).toLocaleString('en-US')}`;
  }

  return '';
};
